import { productAdsAPIClient } from '@/infrastructure/product-ads/api';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks';

export function useProductAds(contextItemId: string) {
  const { isLoading, data, isFetched } = useQuery({
    queryKey: ['product-ads'],
    queryFn: () => productAdsAPIClient.getHomepageAds(contextItemId),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

  return {
    isLoading,
    data,
    isFetched,
  };
}

export function useCountryFilteredProductAds(contextItemId: string) {
  const { selectedValues } = useMultiSelectFilter('Country');
  const filters = {
    Country: selectedValues,
  };
  const { isLoading, data, isFetched } = useQuery({
    queryKey: ['product-ads', contextItemId, JSON.stringify(filters)],
    queryFn: () => productAdsAPIClient.getFilteredProductAds(contextItemId, filters),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

  return {
    isLoading,
    data,
    isFetched,
  };
}

export function useProductAdsRendered(endpoint: string) {
  const { data, isFetched } = useQuery({
    queryKey: ['product-ads-rendered', endpoint],
    queryFn: () => productAdsAPIClient.notifyHomepageAds(endpoint),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

  return {
    data,
    isFetched,
  };
}

export function useUpdateProductAdsViewed(endpoint: string) {
  const { mutateAsync: update } = useMutation({
    mutationFn: () => productAdsAPIClient.notifyHomepageAds(endpoint),
    retry: false,
  });

  return {
    update,
  };
}
